class SvgImage extends HTMLElement {
  constructor() {
    super();
    this.convertImage();

  }
  convertImage() {

    const mainDiv = this.querySelector(".icons-section-media");
    const iamgeUrl = mainDiv?.getAttribute("data-image-url");
    if (iamgeUrl) {
      fetch(iamgeUrl)
        .then(response => {
          if (!response.ok) throw new Error("Network response was not ok");
          return response.text();
        })
        .then(svgText => {
          mainDiv.innerHTML = svgText;

        })
        .catch(error => {
          console.error('Error fetching SVG:', error);
        });
    }
  }
}
customElements.define('svg-image', SvgImage);

document.addEventListener('shopify:section:load', function (event) {
  event.target.querySelectorAll('svg-image').forEach(function (el) {
    el.convertImage();
  });
});